<template lang="pug">
  main
    NavBar
    Loader(v-show="isLoading")
    section.section
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h3.title Registrar Acceso
              | &nbsp
              a.button.is-black.is-rounded(@click="backPage")
                span.icon
                  i.fas.fa-times
        FormVisita(:empleados="empleados" :empleadosAll="empleadosAll" @saveVisita="saveVisita" :origen="origenCorpoVisita")
        .columns.column-blanco
</template>

<script>
  import NavBar from './layout/NavBar'
  import Loader from '@/components/shared/Loader.vue'
  import FormVisita from './components/FormVisita'
  import { mapState } from 'vuex'
  import moment from 'moment'

  import VisitasServices from '@/services/visitas/visitas'

  export default {
    name: 'NuevaAsistencia',
    components: { NavBar, Loader, FormVisita },
    data() {
      return {
        isLoading: false,
        empleados: [],
        empleadosAll: [],
        usuarioSel: {},
      }
    },
    methods: {
      iniciarComponente() {
        this.obtenerUsuarios()
      },

      obtenerUsuarios () {
        this.isLoading = true
        VisitasServices.getEmpleados()
          .then( (res) => {
            const empleadosBD = res.map(this.convertirEmpleados)
            this.empleados = empleadosBD.filter( emp => emp.compania == this.origenCorpoVisita)
            this.empleadosAll = empleadosBD.filter( emp => emp.compania == 1 || emp.compania == 2 || (emp.compania == 0 && emp.ubicacion === 'CORP') )
            this.isLoading = false
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`, 'ban', 'OK')
          })
      },

      convertirEmpleados (emp) {
        return {
          ...emp,
          id: parseInt(emp.id),
          compania: parseInt(emp.compania)
        }
      },

      saveVisita(v) {
        const fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')
        this.isLoading = true

        if (v.primeraVez) {
          VisitasServices.addExterno(v.nombre)
            .then(res => {
              if (res.success) {
                VisitasServices.addVisita(fechaReg, res.idBD, v.temperatura, v.fiebre, v.tos, v.dolorC, v.escurrimiento, v.olfatoGusto,v.dolorM, v.ojosI, v.dolorG, v.dificultadR, v.contactoS, v.contactoC19, v.personaVisita)
                  .then( data => {
                    this.displayToast('toasted-primary', data.respuesta, data.success ? 'check' : 'ban', 'Ok')
                    this.isLoading = false
                    const myObjFirma = this.refactorizarVisita(v, data.idBD)
                    this.$store.commit('registrarVisitaCorpo', myObjFirma)
                    this.$router.push('/Visitas/Corpo/Firma')
                  })
                  .catch(e => {
                    this.isLoading = false
                    this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
                  })
            
              } else {
                this.displayToast('bubble',`Error: ${res.respuesta}`, 'ban', 'OK')
              }
            })
            .catch(e => {
              this.isLoading = false
              this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
            })
        } else {
          VisitasServices.addVisita(fechaReg, v.idEmp, v.temperatura, v.fiebre, v.tos, v.dolorC, v.escurrimiento, v.olfatoGusto, v.dolorM, v.ojosI, v.dolorG, v.dificultadR, v.contactoS, v.contactoC19, v.personaVisita)
            .then( data => {
              if (data.success) {
                  this.displayToast('toasted-primary', data.respuesta, data.success ? 'check' : 'ban', 'Ok')
                  this.isLoading = false
                  const myObjFirma = this.refactorizarVisita(v, data.idBD)
                  this.$store.commit('registrarVisitaCorpo', myObjFirma)
                  this.$router.push('/Visitas/Corpo/Firma')
              } else {
                this.isLoading = false
                this.displayToast('bubble',`Error: ${data.respuesta}`, 'ban', 'OK')
              }
            })
            .catch(e => {
              this.isLoading = false
              this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
            })
        }
      },

      refactorizarVisita(data, id) {
        return {
          ...data,
          id: parseInt(id),
          temperatura: Number(data.temperatura)
        }
      },

      displayToast(tema, text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },

      backPage () {
        this.$router.back()
      },
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['userLogin', 'origenCorpoVisita'])
    }
  }
</script>

<style lang="scss" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/visitas_Componentes/NuevaVisita.vue